var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('backhaul-table',{attrs:{"site-id":_vm.site.id,"provider":true,"read-only":_vm.readOnly,"site-name":_vm.site.siteName,"site-data":_vm.site}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }